<template>
  <v-container grid-list-md pa-0 ma-2 style="max-width: calc(100% - 16px)">
    <v-layout row wrap>
      <v-flex xs12 sm6 md3 lg2>
        <SelectCreditors
          :multiple="false"
          :clearable="false"
          :selected="selectedCreditor"
          :active="true"
          @selectedCreditors="this.setSelectedCreditor"
        ></SelectCreditors>
      </v-flex>
      <v-flex xs12 sm6 md3 lg3>
        <v-select
          box
          flat
          success
          clearable
          item-value="id"
          item-text="name"
          no-data-text="Sem dados"
          class="text-details-none"
          label="Árvore"
          :items="debtBaseList"
          :disabled="!selectedCreditor"
          v-model="selectedDebtBase"
        >
          <template v-slot:item="{ item, attrs, on }">
            <v-list-tile-content v-on="on" v-bind="attrs">
              <div style="display: flex; width: 100%">
                <span
                  class="ma-auto"
                  :class="
                    item.id == selectedDebtBase
                      ? 'primary--text'
                      : item.status == 'ARCHIVED'
                      ? 'grey--text'
                      : ''
                  "
                >
                  {{ item.name }}
                </span>
                <v-spacer></v-spacer>
                <div
                  :class="
                    item.id == selectedDebtBase
                      ? 'deep-purple lighten-5'
                      : setSelectTree(item.status, 'background')
                  "
                  style="border-radius: 50%; padding: 3px; height: 30px"
                >
                  <v-icon
                    :color="
                      item.id == selectedDebtBase
                        ? 'primary'
                        : setSelectTree(item.status, 'color')
                    "
                  >
                    {{ setSelectTree(item.status, "icom") }}
                  </v-icon>
                </div>
              </div>
            </v-list-tile-content>
          </template>
        </v-select>
      </v-flex>
      <v-flex xs12 sm6 md3 lg3>
        <v-select
          box
          flat
          success
          clearable
          :loading="debtNodeLoading"
          item-value="id"
          item-text="name"
          no-data-text="Sem dados"
          class="text-details-none"
          label="Nó"
          :items="debtNodeList"
          :disabled="!selectedDebtBase"
          v-model="selectedDebtNode"
        >
          <template v-slot:item="{ item, attrs, on }">
            <v-list-tile-content v-on="on" v-bind="attrs">
              <div style="display: flex; width: 100%">
                <span
                  class="ma-auto"
                  :class="
                    item.id == selectedDebtNode
                      ? 'primary--text'
                      : item.active == false
                      ? 'grey--text'
                      : ''
                  "
                >
                  {{ item.name }}
                </span>
                <v-spacer></v-spacer>
              </div>
            </v-list-tile-content>
          </template>
        </v-select>
      </v-flex>
      <v-flex
        xs12
        sm6
        md3
        lg2
        style="height: min-content"
        id="date-picker-range"
      >
        <v-md-date-range-picker
          style="margin: 0px !important"
          :opens="'right'"
          @change="handleChange"
          :presets="presets"
          :start-date="startDate"
          :end-date="endDate"
        ></v-md-date-range-picker>
      </v-flex>
      <v-flex xs12 sm6 md1 lg1>
        <v-btn
          large
          :class="`${accent ? 'accent' : ''}`"
          @click="getScreenContent()"
          :disabled="checkButtonUpdate()"
          >Atualizar</v-btn
        >
      </v-flex>
      <v-expand-transition>
        <v-layout wrap v-show="selected.length >= 1">
          <v-btn
            color="accent"
            style="border-radius: 5px"
            @click="generateReport()"
            >Extrair Relatório
          </v-btn>

          <v-btn
            flat
            icon
            large
            class="my-0 py-0"
            color="accent"
            @click="selected = []"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-layout>
      </v-expand-transition>
      <v-flex xs12 class="stimulus-history" v-if="stimulusHistorys">
        <v-data-table
          locale="pt-br"
          no-data-text="Nenhum estímulo encontrado"
          style="border: 1px solid rgba(0, 0, 0, 0.12); border-radius: 4px"
          :headers="headers_node"
          :items="nodesArray"
          item-key="debt_node_id"
          :custom-sort="customSortNode"
          :expand="expand"
          :disable-pagination="true"
          :hide-default-footer="true"
          :hide-actions="true"
        >
          <template v-slot:items="props">
            <tr @click="expansorNode(props)" style="cursor: pointer">
              <td
                style="
                  text-align: left;
                  padding-left: 10px !important;
                  background-color: #e1f5fe;
                "
              >
                {{ props.item.debt_node_id }} -
                {{ nodeName(props.item.debt_node_id, debtNodeList) }}
              </td>
              <td style="background-color: #e1f5fe"></td>
              <td style="text-align: center; background-color: #e1f5fe">
                {{ props.item.sumAmountCustomers | numeral("0,0") }} /
                {{ props.item.sumAmountContacts | numeral("0,0") }}
              </td>
              <td style="text-align: right; background-color: #e1f5fe">
                {{ props.item.sumAmountNotified | numeral("0,0") }}
                <v-btn
                  icon
                  small
                  :style="`color: ${props.item.skipObj.color}`"
                  class="ma-0 pa-0 ml-1"
                  v-if="props.item.skipObj && props.item.skipObj.show"
                  @click.native.stop="setSkipsNodes(props.item)"
                >
                  <v-icon>mdi-alert-outline</v-icon>
                </v-btn>
              </td>
              <td style="text-align: center; background-color: #e1f5fe">
                <span>
                  {{ props.item.taxaDelivered | numeral("0.00%") }}
                </span>
                <span style="font-weight: bold">
                  ({{ props.item.sumAmountDelivered | numeral("0,0") }})
                </span>
              </td>
              <td style="text-align: center; background-color: #e1f5fe">
                <span>
                  {{ props.item.taxaInteresse | numeral("0.00%") }}
                </span>
                <span style="font-weight: bold">
                  ({{ props.item.sumAmountAccessed | numeral("0,0") }})
                </span>
              </td>
              <td style="text-align: center; background-color: #e1f5fe">
                <span>
                  {{ props.item.taxaLogados | numeral("0.00%") }}
                </span>
                <span style="font-weight: bold">
                  ({{ props.item.sumAmountLoggedIn | numeral("0,0") }})
                </span>
              </td>
              <td style="text-align: center; background-color: #e1f5fe">
                <span>
                  {{ props.item.taxaDealViewed | numeral("0.00%") }}
                </span>
                <span style="font-weight: bold">
                  ({{ props.item.sumAmountDealViewed | numeral("0,0") }})
                </span>
              </td>
              <td style="text-align: center; background-color: #e1f5fe">
                <span>
                  {{ props.item.taxaConversao | numeral("0.00%") }}
                </span>
                <span style="font-weight: bold">
                  ({{ props.item.sumAmountProposalConfirmed | numeral("0,0") }})
                </span>
              </td>
              <td style="text-align: center; background-color: #e1f5fe">
                <span>
                  {{ props.item.taxaImplantacao | numeral("0.00%") }}
                </span>
                <span style="font-weight: bold">
                  ({{ props.item.sumAmountProposalAgreed | numeral("0,0") }})
                </span>
              </td>
              <td style="text-align: center; background-color: #e1f5fe">
                <div v-if="props.item.sumAmountCost">
                  {{ props.item.sumAmountCost | numeral("$ 0,0.00") }}<br />
                </div>
                <div v-else>{{ 0 | numeral("$ 0,0.00") }}<br /></div>
                <div v-if="props.item.sumAmountProposalAgreed">
                  ({{
                    (props.item.sumAmountCost /
                      props.item.sumAmountProposalAgreed)
                      | numeral("$ 0,0.00")
                  }}
                  CPP) <br />
                </div>
                <div v-else>({{ 0 | numeral("$ 0,0.00") }} CPP)<br /></div>
                <div v-if="props.item.sumAmountLoggedIn">
                  ({{
                    (props.item.sumAmountCost / props.item.sumAmountLoggedIn)
                      | numeral("$ 0,0.00")
                  }}
                  CPL)
                </div>
                <div v-else>({{ 0 | numeral("$ 0,0.00") }} CPL)</div>
              </td>
              <td
                v-if="props.item.sumAmountProposalAgreed"
                style="text-align: center; background-color: #e1f5fe"
              >
                {{ props.item.ppp | numeral("$ 0,0.00") }}
              </td>
              <td v-else style="text-align: center; background-color: #e1f5fe">
                {{ 0 | numeral("$ 0,0.00") }}
              </td>
              <td
                v-if="props.item.sumAmountCost"
                style="text-align: center; background-color: #e1f5fe"
              >
                {{ props.item.cc | numeral("0.00") }}
              </td>
              <td v-else style="text-align: center; background-color: #e1f5fe">
                {{ 0 | numeral("0.00") }}
              </td>
            </tr>
          </template>
          <template v-slot:expand="">
            <v-card flat class="stimulus-history">
              <v-data-table
                :headers="headers_stimulus"
                :items="stimulus"
                item-key="stimulus_id"
                :expand="expand"
                :custom-sort="customSortStimulus"
                elevation-5
                :disable-pagination="true"
                :hide-default-footer="true"
                :hide-actions="true"
              >
                <template v-slot:items="props">
                  <tr
                    class="pa-0"
                    @click="expansorStimulus(props)"
                    style="cursor: pointer"
                  >
                    <td style="background-color: #e0f2f1"></td>
                    <td
                      style="
                        text-align: left;
                        padding-left: 10px !important;
                        background-color: #e0f2f1;
                      "
                    >
                      <div class="text-truncate" style="display: flex; align-items: center; gap:1rem;">
                        <span style="margin-top: 1.5rem" @click.stop>
                          <v-checkbox
                            v-model="selected"
                            :value="props.item"
                          ></v-checkbox>
                        </span>
                        <span
                          >{{ props.item.stimulus_id }} -
                          {{ props.item.stimulus_name }}
                        </span>
                        <v-tooltip top v-if="props.item.hot">
                          <template v-slot:activator="{ on }">
                            <span
                              class="red lighten-4 red--text text--darken-2"
                              style="
                                font-size: 11px;
                                line-height: 12px;
                                padding: 2px 4px 0px 4px;
                                border-radius: 4px;
                                font-weight: 500;
                              "
                            >
                              HOT
                            </span>
                          </template>
                        </v-tooltip>
                      </div>
                    </td>
                    <td style="background-color: #e0f2f1"></td>
                    <td style="text-align: center; background-color: #e0f2f1">
                      {{ props.item.sumAmountCustomers | numeral("0,0") }} /
                      {{ props.item.sumAmountContacts | numeral("0,0") }}
                    </td>
                    <td style="text-align: right; background-color: #e0f2f1">
                      {{ props.item.sumAmountNotified | numeral("0,0") }}
                      <v-btn
                        icon
                        small
                        :style="`color: ${props.item.skipObj.color}`"
                        class="ma-0 pa-0 ml-1"
                        v-if="props.item.skipObj && props.item.skipObj.show"
                        @click.native.stop="setSkipsStimulus(props.item)"
                      >
                        <v-icon>mdi-alert-outline</v-icon>
                      </v-btn>
                    </td>
                    <td style="text-align: center; background-color: #e0f2f1">
                      <span>
                        {{ props.item.taxaDelivered | numeral("0.00%") }}
                      </span>
                      <span style="font-weight: bold">
                        ({{ props.item.sumAmountDelivered | numeral("0,0")}})
                      </span>
                    </td>
                    <td style="text-align: center; background-color: #e0f2f1">
                      <span>
                        {{ props.item.taxaInteresse | numeral("0.00%") }}
                      </span>
                      <span style="font-weight: bold">
                        ({{ props.item.sumAmountAccessed | numeral("0,0") }})
                      </span>
                    </td>
                    <td style="text-align: center; background-color: #e0f2f1">
                      <span>
                        {{ props.item.taxaLogados | numeral("0.00%") }}
                      </span>
                      <span style="font-weight: bold">
                        ({{ props.item.sumAmountLoggedIn | numeral("0,0") }})
                      </span>
                    </td>
                    <td style="text-align: center; background-color: #e0f2f1">
                      <span>
                        {{ props.item.taxaDealViewed | numeral("0.00%") }}
                      </span>
                      <span style="font-weight: bold">
                        ({{ props.item.sumAmountDealViewed | numeral("0,0") }})
                      </span>
                    </td>
                    <td style="text-align: center; background-color: #e0f2f1">
                      <span>
                        {{ props.item.taxaConversao | numeral("0.00%") }}
                      </span>
                      <span style="font-weight: bold">
                        ({{
                          props.item.sumAmountProposalConfirmed
                            | numeral("0,0")
                        }})
                      </span>
                    </td>
                    <td style="text-align: center; background-color: #e0f2f1">
                      <span>
                        {{ props.item.taxaImplantacao | numeral("0.00%") }}
                      </span>
                      <span style="font-weight: bold">
                        ({{
                          props.item.sumAmountProposalAgreed | numeral("0,0")
                        }})
                      </span>
                    </td>
                    <td style="text-align: center; background-color: #e0f2f1">
                      <div v-if="props.item.sumAmountCost">
                        {{ props.item.sumAmountCost | numeral("$ 0,0.00")
                        }}<br />
                      </div>
                      <div v-else>{{ 0 | numeral("$ 0,0.00") }}<br /></div>
                      <div v-if="props.item.sumAmountProposalAgreed">
                        ({{
                          (props.item.sumAmountCost /
                            props.item.sumAmountProposalAgreed)
                            | numeral("$ 0,0.00")
                        }}
                        CPP) <br />
                      </div>
                      <div v-else>({{ 0 | numeral("$ 0,0.00") }} CPP)</div>
                      <div v-if="props.item.sumAmountLoggedIn">
                        ({{
                          (props.item.sumAmountCost /
                            props.item.sumAmountLoggedIn)
                            | numeral("$ 0,0.00")
                        }}
                        CPL)
                      </div>
                      <div v-else>({{ 0 | numeral("$ 0,0.00") }} CPL)</div>
                    </td>
                    <td
                      v-if="props.item.sumAmountProposalAgreed"
                      style="text-align: center; background-color: #e0f2f1"
                    >
                      {{ props.item.ppp | numeral("$ 0,0.00") }}
                    </td>
                    <td
                      v-else
                      style="text-align: center; background-color: #e0f2f1"
                    >
                      {{ 0 | numeral("$ 0,0.00") }}
                    </td>
                    <td
                      v-if="props.item.sumAmountCost"
                      style="text-align: center; background-color: #e0f2f1"
                    >
                      {{ props.item.cc | numeral("0.00") }}
                    </td>
                    <td
                      v-else
                      style="text-align: center; background-color: #e0f2f1"
                    >
                      {{ 0 | numeral("0.00") }}
                    </td>
                  </tr>
                </template>
                <template v-slot:expand="">
                  <v-card flat>
                    <v-data-table
                      :headers="headers_histories"
                      :custom-sort="customSortHistories"
                      :items="histories"
                      item-key="id"
                      elevation-5
                      :disable-pagination="true"
                      :hide-default-footer="true"
                      :hide-actions="true"
                    >
                      <template slot="headerCell" slot-scope="props">
                        <v-tooltip top dark>
                          <template v-slot:activator="{ on }">
                            <span v-if="props.header.text === 'Dia'" v-on="on"
                              >{{ props.header.text }} <br />Offset - Hora</span
                            >
                            <span v-else v-on="on">{{
                              props.header.text
                            }}</span>
                          </template>
                          <span v-if="props.header.text === 'Dia'"
                            >{{ props.header.text }} <br />Offset - Hora</span
                          >
                          <span v-else>{{ props.header.text }}</span>
                        </v-tooltip>
                      </template>
                      <template v-slot:items="props">
                        <tr>
                          <td style="background-color: #ede7f6"></td>
                          <td
                            style="
                              text-align: center;
                              background-color: #ede7f6;
                            "
                          >
                            <div>
                              <span
                                :class="`tag-approach-type small ${props.item.approach_type}`"
                                >{{ props.item.approach_type }}</span
                              >
                            </div>
                          </td>
                          <td
                            style="
                              text-align: center;
                              background-color: #ede7f6;
                            "
                          >
                            <div>
                              {{
                                moment(props.item.created_at).format(
                                  "DD-MM-YYYY"
                                )
                              }}
                            </div>
                            <div>
                              {{ props.item.approach_offset }} -
                              <span
                                v-html="isRetroactive(props.item.approach_time)"
                              ></span
                              >h
                            </div>
                          </td>
                          <td
                            style="
                              text-align: center;
                              background-color: #ede7f6;
                            "
                          >
                            {{ selectContent(props) }}
                          </td>
                          <td
                            style="
                              text-align: center;
                              background-color: #ede7f6;
                            "
                          >
                            {{ props.item.customers | numeral("0,0") }} /
                            {{ props.item.contacts | numeral("0,0") }}
                          </td>
                          <td
                            style="
                              text-align: center;
                              background-color: #ede7f6;
                            "
                          >
                            {{ props.item.notified | numeral("0,0") }}
                            <!-- <v-btn
                              icon
                              small
                              :style="`color: ${props.item.skipObj.color}`"
                              v-if="props.item.skipObj && props.item.skipObj.show"
                              class="ma-0 pa-0 ml-1"
                              @click.native.stop="setSkipsHistories(props.item)"
                              
                            >
                              <v-icon
                              
                                >mdi-alert-outline</v-icon
                              >
                            </v-btn> -->
                          </td>
                          <td
                            style="
                              text-align: center;
                              background-color: #ede7f6;
                            "
                          >
                            <span>
                              {{
                                (props.item.notified
                                  ? props.item.delivered /
                                    props.item.notified
                                  : 0) | numeral("0.00%")
                              }}
                            </span>
                            <span style="font-weight: bold">
                              ({{ props.item.delivered | numeral("0,0") }})
                            </span>
                          </td>
                          <td
                            style="
                              text-align: center;
                              background-color: #ede7f6;
                            "
                          >
                            <span v-if="props.item.notified">
                              {{ props.item.taxaInteresse | numeral("0.00%") }}
                            </span>
                            <span v-else>
                              {{ 0 | numeral("0.00%") }}
                            </span>
                            <span style="font-weight: bold">
                              ({{ props.item.accessed | numeral("0,0") }})
                            </span>
                          </td>
                          <td
                            style="
                              text-align: center;
                              background-color: #ede7f6;
                            "
                          >
                            <span v-if="props.item.accessed">
                              {{ props.item.taxaLogados | numeral("0.00%") }}
                            </span>
                            <span v-else>
                              {{ 0 | numeral("0.00%") }}
                            </span>
                            <span style="font-weight: bold">
                              ({{ props.item.logged_in | numeral("0,0") }})
                            </span>
                          </td>
                          <td
                            style="
                              text-align: center;
                              background-color: #ede7f6;
                            "
                          >
                            <span v-if="props.item.logged_in">
                              {{ props.item.taxaDealViewed | numeral("0.00%") }}
                            </span>
                            <span v-else>
                              {{ 0 | numeral("0.00%") }}
                            </span>
                            <span style="font-weight: bold">
                              ({{ (props.item.deal_viewed || 0) | numeral("0,0") }})
                            </span>
                          </td>
                          <td
                            style="
                              text-align: center;
                              background-color: #ede7f6;
                            "
                          >
                            <span v-if="props.item.logged_in">
                              {{ props.item.taxaConversao | numeral("0.00%") }}
                            </span>
                            <span v-else>
                              {{ 0 | numeral("0.00%") }}
                            </span>
                            <span style="font-weight: bold">
                              ({{
                                props.item.proposal_confirmed | numeral("0,0")
                              }})
                            </span>
                          </td>
                          <td
                            style="
                              text-align: center;
                              background-color: #ede7f6;
                            "
                          >
                            <span v-if="props.item.proposal_confirmed">
                              {{
                                props.item.taxaImplantacao | numeral("0.00%")
                              }}
                            </span>
                            <span v-else>
                              {{ 0 | numeral("0.00%") }}
                            </span>
                            <span style="font-weight: bold">
                              ({{
                                props.item.proposal_agreed | numeral("0,0")
                              }})
                            </span>
                          </td>
                          <td
                            style="
                              text-align: center;
                              background-color: #ede7f6;
                            "
                          >
                            <div v-if="props.item.notification_cost">
                              {{
                                props.item.notification_cost
                                  | numeral("$ 0,0.00")
                              }}<br />
                            </div>
                            <div v-else-if="props.item.approach_cost">
                              {{
                                (props.item.notified * props.item.approach_cost)
                                  | numeral("$ 0,0.00")
                              }}<br />
                            </div>
                            <div v-else>
                              {{ 0 | numeral("$ 0,0.00") }}<br />
                            </div>
                            <div
                              v-if="
                                props.item.notification_cost &&
                                props.item.proposal_agreed > 0
                              "
                            >
                              ({{
                                (props.item.notification_cost /
                                  props.item.proposal_agreed)
                                  | numeral("$ 0,0.00")
                              }}
                              CPP) <br />
                            </div>
                            <div v-else-if="props.item.proposal_agreed">
                              ({{
                                ((props.item.notified *
                                  props.item.approach_cost) /
                                  props.item.proposal_agreed)
                                  | numeral("$ 0,0.00")
                              }}
                              CPP) <br />
                            </div>
                            <div v-else>
                              ({{ 0 | numeral("$ 0,0.00") }} CPP)
                            </div>
                            <div
                              v-if="
                                props.item.notification_cost &&
                                props.item.logged_in > 0
                              "
                            >
                              ({{
                                (props.item.notification_cost /
                                  props.item.logged_in)
                                  | numeral("$ 0,0.00")
                              }}
                              CPL)
                            </div>
                            <div v-else-if="props.item.logged_in">
                              ({{
                                ((props.item.notified *
                                  props.item.approach_cost) /
                                  props.item.logged_in)
                                  | numeral("$ 0,0.00")
                              }}
                              CPL)
                            </div>
                            <div v-else>
                              ({{ 0 | numeral("$ 0,0.00") }} CPL)
                            </div>
                          </td>
                          <td
                            v-if="props.item.proposal_agreed"
                            style="
                              text-align: center;
                              background-color: #ede7f6;
                            "
                          >
                            {{ props.item.ppp | numeral("$ 0,0.00") }}
                          </td>
                          <td
                            v-else
                            style="
                              text-align: center;
                              background-color: #ede7f6;
                            "
                          >
                            {{ 0 | numeral("$ 0,0.00") }}
                          </td>
                          <td
                            v-if="props.item.approach_cost"
                            style="
                              text-align: center;
                              background-color: #ede7f6;
                            "
                          >
                            {{ props.item.cc | numeral("0.00") }}
                          </td>
                          <td
                            v-else
                            style="
                              text-align: center;
                              background-color: #ede7f6;
                            "
                          >
                            {{ 0 | numeral("0.00") }}
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-card>
                </template>
              </v-data-table>
            </v-card>
          </template>

          <template v-slot:no-data>
            <v-container
              fluid
              fill-height
              style="background-color: rgba(255, 255, 255, 0.5)"
            >
              <v-layout justify-center align-center>
                <v-progress-circular
                  v-if="loading"
                  indeterminate
                  color="primary"
                ></v-progress-circular>
                <strong
                  v-if="!loading"
                  class="py-2"
                  style="font-color: red; font-size: 14px"
                  >Nenhum estímulo encontrado</strong
                >
              </v-layout>
            </v-container>
          </template>
        </v-data-table></v-flex
      ></v-layout
    >
    <v-dialog
      v-model="dialog"
      scrollable
      max-height="50vh"
      max-width="50vw"
      :fullscreen="$vuetify.breakpoint.smAndDown"
    >
      <v-card>
        <v-card-title>
          <span v-if="skipObj.debt_node_id" class="headline">
            {{ skipObj.debt_node_id }} -
            {{ nodeName(skipObj.debt_node_id, debtNodeList) }}</span
          >
          <span v-if="skipObj.stimulus_id" class="headline">
            {{ skipObj.stimulus_id }} - {{ skipObj.stimulus_name }}</span
          >
          <!-- <span v-if="skipObj.approach_time" class="headline"> {{skipObj.approach_offset}} - {{isRetroactiveDialog(skipObj.approach_time)}}</span> -->
          <v-spacer></v-spacer>
          <v-btn
            class="text-xs-right"
            flat
            icon
            color="black"
            @click="dialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text
          :style="`${
            $vuetify.breakpoint.smAndDown ? 'height: 55vh' : 'height: 40vh'
          }`"
        >
          <v-divider></v-divider>
          <div>
            <strong
              v-if="skipObj.sumAmountContacts"
              class="layout pt-3 px-4 pb-1 row justify-space-between"
              >Preparadas
              <strong
                >{{ skipObj.sumAmountContacts | numeral("0,0") }}
              </strong></strong
            >
            <!-- <strong v-else class="layout pt-3 px-4 pb-1 row justify-space-between">Preparadas <strong >{{ skipObj.prepared | numeral("0,0") }}</strong></strong> -->
            <strong class="layout pt-3 px-4 pb-1 row justify-space-between"
              >Enviadas
              <strong>{{
                skipObj.sumAmountNotified | numeral("0,0")
              }}</strong></strong
            >
            <!-- <strong v-else class="layout pt-3 px-4 pb-1 row justify-space-between">Enviadas <strong >{{ skipObj.notified | numeral("0,0") }}</strong></strong>        -->
          </div>
          <v-divider></v-divider>
          <div column>
            <div
              v-for="(skip, index) in validSkips"
              :key="skip.value + index"
              class="layout pt-3 px-4 pb-1 row justify-space-between"
            >
              <strong> {{ skip.name }} </strong>
              <strong :style="`color: ${skip.color}`" class="text--darken-3">
                {{ skipObj[skip.value] | numeral("0,0") }}</strong
              >
            </div>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <strong
          class="layout pt-3 px-5 pb-4 row justify-space-between"
          style="font-size: 18px"
        >
          Total de mensagens não enviadas:
          <strong style="text-align: right; font-size: 18px">{{
            skipObj.total | numeral("0,0")
          }}</strong></strong
        >
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import moment from "moment";
import store from "@/store";
import SelectCreditors from "@/components/creditor/SelectCreditors";
import gatewaysService from "@/services/gateways";
import skips from "@/utils/skips-types";
import reportingService from "@/services/reporting/reporting";
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  data() {
    return {
      debtNodeLoading: false,
      activeUpdateButton: false,
      accent: false,
      dialog: false,
      selected: [],
      skips: [],
      histories: [],
      stimulus: [],
      nodesArray: [],
      gateways: [],
      skipObj: {},
      moment: moment,
      expand: false,
      headers_node: [
        {
          text: "ID - Node",
          align: "left",
          value: "debt_node_id",
          width: "17%",
          sortable: true,
          class: "font-weight-regular light-blue lighten-4",
        },
        {
          text: "",
          align: "center",
          value: "",
          width: "21%",
          sortable: false,
          class: "font-weight-regular light-blue lighten-4",
        },
        {
          text: "Clientes / Contatos",
          align: "center",
          value: "sumAmountCustomers",
          width: "9%",
          sortable: true,
          class: "font-weight-regular light-blue lighten-4",
        },
        {
          text: "Notificados",
          align: "center",
          value: "sumAmountNotified",
          width: "6%",
          sortable: true,
          class: "font-weight-regular light-blue lighten-4",
        },
        {
          text: "Taxa de Entrega",
          align: "center",
          value: "sumAmountDelivered",
          width: "6%",
          sortable: true,
          class: "font-weight-regular light-blue lighten-4",
        },
        {
          text: "Taxa de Interesse",
          align: "center",
          value: "taxaInteresse",
          width: "6%",
          sortable: true,
          class: "font-weight-regular light-blue lighten-4",
        },
        {
          text: "Taxa de Logados",
          align: "center",
          value: "taxaLogados",
          width: "6%",
          sortable: true,
          class: "font-weight-regular light-blue lighten-4",
        },
        {
          text: "Deal Visualizado",
          align: "center",
          value: "taxaDealViewed",
          width: "6%",
          sortable: true,
          class: "font-weight-regular light-blue lighten-4",
        },
        {
          text: "Taxa de Conversão",
          align: "center",
          value: "taxaConversao",
          width: "6%",
          sortable: true,
          class: "font-weight-regular light-blue lighten-4",
        },
        {
          text: "Taxa de Implantação",
          align: "center",
          value: "taxaImplantacao",
          width: "6%",
          sortable: true,
          class: "font-weight-regular light-blue lighten-4",
        },
        {
          text: "Custo",
          align: "center",
          value: "sumAmountCost",
          width: "12%",
          sortable: true,
          class: "font-weight-regular light-blue lighten-4",
        },
        {
          text: "PPP",
          align: "center",
          value: "ppp",
          width: "6%",
          sortable: true,
          class: "font-weight-regular light-blue lighten-4",
        },
        {
          text: "CC",
          align: "center",
          value: "cc",
          width: "6%",
          sortable: true,
          class: "font-weight-regular light-blue lighten-4",
        },
      ],
      headers_stimulus: [
        {
          text: "",
          align: "center",
          value: "",
          width: "1%",
          sortable: false,
          class: "font-weight-regular teal lighten-4",
        },
        {
          text: "ID - Estímulo",
          align: "left",
          value: "stimulus_id",
          width: "25%",
          sortable: true,
          class: "font-weight-regular teal lighten-4",
        },
        {
          text: "",
          align: "center",
          value: "",
          width: "11%",
          sortable: false,
          class: "font-weight-regular teal lighten-4",
        },
        {
          text: "Clientes / Contatos",
          align: "center",
          value: "sumAmountCustomers",
          width: "9%",
          sortable: true,
          class: "font-weight-regular teal lighten-4",
        },
        {
          text: "Notificados",
          align: "center",
          value: "sumAmountNotified",
          width: "6%",
          sortable: true,
          class: "font-weight-regular teal lighten-4",
        },
        {
          text: "Taxa de Entrega",
          align: "center",
          value: "sumAmountDelivered",
          width: "6%",
          sortable: true,
          class: "font-weight-regular teal lighten-4",
        },
        {
          text: "Taxa de Interesse",
          align: "center",
          value: "taxaInteresse",
          width: "6%",
          sortable: true,
          class: "font-weight-regular teal lighten-4",
        },
        {
          text: "Taxa de Logados",
          align: "center",
          value: "taxaLogados",
          width: "6%",
          sortable: true,
          class: "font-weight-regular teal lighten-4",
        },
        {
          text: "Deal Visualizado",
          align: "center",
          value: "taxaDealViewed",
          width: "6%",
          sortable: true,
          class: "font-weight-regular teal lighten-4",
        },
        {
          text: "Taxa de Conversão",
          align: "center",
          value: "taxaConversao",
          width: "6%",
          sortable: true,
          class: "font-weight-regular teal lighten-4",
        },
        {
          text: "Taxa de Implantação",
          align: "center",
          value: "taxaImplantacao",
          width: "6%",
          sortable: true,
          class: "font-weight-regular teal lighten-4",
        },
        {
          text: "Custo",
          align: "center",
          value: "sumAmountCost",
          width: "12%",
          sortable: true,
          class: "font-weight-regular teal lighten-4",
        },
        {
          text: "PPP",
          align: "center",
          value: "ppp",
          width: "6%",
          sortable: true,
          class: "font-weight-regular teal lighten-4",
        },
        {
          text: "CC",
          align: "center",
          value: "cc",
          width: "6%",
          sortable: true,
          class: "font-weight-regular teal lighten-4",
        },
      ],
      headers_histories: [
        {
          text: "",
          align: "center",
          value: "",
          width: "2%",
          sortable: false,
          class: "font-weight-regular deep-purple lighten-4",
        },
        {
          text: "Abordagem",
          align: "center",
          value: "approach_type",
          width: "3%",
          sortable: false,
          class: "font-weight-regular deep-purple lighten-4",
        },
        {
          text: "Dia",
          align: "center",
          value: "approach_offset",
          width: "11%",
          sortable: true,
          class: "font-weight-regular deep-purple lighten-4",
        },
        {
          text: "Conteúdo",
          align: "center",
          value: "stimulus_content",
          width: "20%",
          sortable: false,
          class: "font-weight-regular deep-purple lighten-4",
        },
        {
          text: "Clientes / Contatos",
          align: "center",
          value: "customers",
          width: "9%",
          sortable: true,
          class: "font-weight-regular deep-purple lighten-4",
        },
        {
          text: "Notificados",
          align: "center",
          value: "notified",
          width: "6%",
          sortable: true,
          class: "font-weight-regular deep-purple lighten-4",
        },
        {
          text: "Taxa de Entrega",
          align: "center",
          value: "delivered",
          width: "6%",
          sortable: true,
          class: "font-weight-regular deep-purple lighten-4",
        },
        {
          text: "Taxa de Interesse",
          align: "center",
          value: "taxaInteresse",
          width: "6%",
          sortable: true,
          class: "font-weight-regular deep-purple lighten-4",
        },
        {
          text: "Taxa de Logados",
          align: "center",
          value: "taxaLogados",
          width: "6%",
          sortable: true,
          class: "font-weight-regular deep-purple lighten-4",
        },
        {
          text: "Deal Visualizado",
          align: "center",
          value: "taxaDealViewed",
          width: "6%",
          sortable: true,
          class: "font-weight-regular deep-purple lighten-4",
        },
        {
          text: "Taxa de Conversão",
          align: "center",
          value: "taxaConversao",
          width: "6%",
          sortable: true,
          class: "font-weight-regular deep-purple lighten-4",
        },
        {
          text: "Taxa de Implantação",
          align: "center",
          value: "taxaImplantacao",
          width: "7%",
          sortable: true,
          class: "font-weight-regular deep-purple lighten-4",
        },
        {
          text: "Custo",
          align: "center",
          value: "sumAmountCost",
          width: "12%",
          sortable: false,
          class: "font-weight-regular deep-purple lighten-4",
        },
        {
          text: "PPP",
          align: "center",
          value: "ppp",
          width: "6%",
          sortable: true,
          class: "font-weight-regular deep-purple lighten-4",
        },
        {
          text: "CC",
          align: "center",
          value: "cc",
          width: "6%",
          sortable: true,
          class: "font-weight-regular deep-purple lighten-4",
        },
      ],
      presets: [
        {
          label: "Hoje",
          range: this.getRange(0, 0),
        },
        {
          label: "Ontem",
          range: this.getRange(1, 1),
        },
        {
          label: "Últimos 7 dias",
          range: this.getRange(6, 0),
        },
        {
          label: "Últimos 30 dias",
          range: this.getRange(29, 0),
        },
        {
          label: "Este mês",
          range: this.getRange(0, 0, "month"),
        },
        {
          label: "Mês passado",
          range: this.getRange(1, 1, "month"),
        },
      ],
    };
  },
  components: {
    SelectCreditors,
  },
  async created() {
    this.skips = skips.skips;
    await this.getGateway();
    await this.loadParams();
  },
  computed: {
    ...mapGetters("stimulusHistory", {
      selectedCreditor: "selectedCreditor",
      selectedDebtBaseGetter: "selectedDebtBase",
      selectedDebtNodeGetter: "selectedDebtNode",
      debtBaseList: "debtBaseList",
      debtNodeList: "debtNodeList",
      startDate: "startDate",
      endDate: "endDate",
      loading: "doUpdate",
      haveParams: "haveParams",
      stimulusHistorys: "stimulusHistorys",
    }),
    validSkips() {
      return this.skips.filter((skip) => this.skipObj[skip.value] > 0);
    },
    selectedDebtBase: {
      get: function () {
        return this.selectedDebtBaseGetter;
      },
      set: function (newValue) {
        this.setSelectedDebtBase(newValue);
      },
    },
    selectedDebtNode: {
      get: function () {
        return this.selectedDebtNodeGetter;
      },
      set: function (newValue) {
        this.setSelectedDebtNode(newValue);
      },
    },
  },
  watch: {
    async selectedCreditor(newValue, oldValue) {
      this.clearStimulusHistorys();
      if (newValue && newValue != oldValue) {
        if (oldValue) {
          this.clearSelectedDebtBase();
          this.clearHaveParams();
        }
        await this.loadDebtBases();
        this.$router.replace({
          query: { ...this.$route.query, creditor: newValue },
        });
      }
    },
    async selectedDebtBase(newValue, oldValue) {
      this.clearStimulusHistorys();
      if (newValue != oldValue) {
        this.debtNodeLoading = true;
        if (oldValue) {
          this.clearSelectedDebtNode();
          this.clearHaveParams();
        }
        this.$router.replace({
          query: { ...this.$route.query, baseId: newValue },
        });
        if (newValue) {
          await this.loadDebtNodes();
        }
        this.debtNodeLoading = false;
      }
    },
    async selectedDebtNode(newValue, oldValue) {
      this.clearStimulusHistorys();
      if (newValue != oldValue) {
        this.$router.replace({
          query: { ...this.$route.query, nodeId: newValue },
        });
      }
      if (this.selectedCreditor && this.selectedDebtBase && !this.loading) {
        this.clearHaveParams();
      }
    },
    async startDate(newValue, oldValue) {
      this.clearStimulusHistorys();
      if (newValue != oldValue) {
        this.$router.replace({
          query: { ...this.$route.query, start: newValue },
        });
      }
      if (this.selectedCreditor && this.selectedDebtBase && !this.loading) {
        this.clearHaveParams();
      }
    },
    async endDate(newValue, oldValue) {
      this.clearStimulusHistorys();
      if (newValue != oldValue) {
        this.$router.replace({
          query: { ...this.$route.query, end: newValue },
        });
      }
      if (this.selectedCreditor && this.selectedDebtBase && !this.loading) {
        this.clearHaveParams();
      }
    },
    async stimulusHistorys(newValue, oldValue) {
      if (newValue && newValue.length > 0 && newValue != oldValue) {
        this.setStimulus(newValue);
      }
    },
    dialog: {
      handler() {
        if (!this.dialog) this.stimulusHistory = {};
      },
    },
  },
  methods: {
    ...mapMutations("stimulusHistory", {
      setSelectedCreditor: "setSelectedCreditor",
      setSelectedDebtBase: "setSelectedDebtBase",
      clearSelectedDebtBase: "clearSelectedDebtBase",
      setSelectedDebtNode: "setSelectedDebtNode",
      clearSelectedDebtNode: "clearSelectedDebtNode",
      clearDoUpdate: "clearDoUpdate",
      setStartDate: "setStartDate",
      setEndDate: "setEndDate",
      setHaveParams: "setHaveParams",
      clearHaveParams: "clearHaveParams",
      clearStimulusHistorys: "clearStimulusHistorys",
    }),
    ...mapActions("stimulusHistory", {
      loadDebtBases: "loadDebtBases",
      loadParams: "loadParams",
      loadDebtNodes: "loadDebtNodes",
      searchStimulusHistory: "searchStimulusHistory",
    }),

    getScreenContent() {
      this.nodesArray = [];
      this.clearStimulusHistorys();
      this.searchStimulusHistory();
      this.setHaveParams(true);
    },

    checkButtonUpdate() {
      if (
        this.selectedCreditor &&
        this.selectedDebtBase &&
        !this.haveParams &&
        !this.loading
      ) {
        this.accent = true;
        return false;
      }
      return true;
    },
    generateReport() {
      let ids = [];
      let firing_ids = [];
      let type = null;
      this.selected.forEach((item) => ids.push(item.firing_id));
      ids = [...new Set(ids.flat())];
      if (ids.length > 1) {
        type = "MANY_FIRING";
        firing_ids = ids;
      } else {
        type = "FIRING";
        firing_ids = [ids[0]];
      }

      reportingService
        .generateReport(type, firing_ids)
        .then((resp) => {
          this.$store.commit("showSnackbar", "Relatório gerado com sucesso.");
        })
        .catch((err) => {
          console.error(err);
          this.$store.commit(
            "showSnackbar",
            "Houve um erro ao gerar o relatório."
          );
        });
    },
    async getGateway() {
      await gatewaysService.gateways().then((resp) => {
        resp.objects.forEach((item) => {
          this.gateways.push({
            id: item.id,
            name: item.name,
          });
        });
      });
    },
    nodeName(id, nodes = []) {
      if (!id) return "";
      let node = nodes.find((n) => n.id == id);
      return node ? node.name : "";
    },
    customSortNode(items, column, isDesc = false) {
      if (column == "debt_node_id") {
        items.sort((a, b) => {
          return Number(a["debt_node_id"]) < Number(b["debt_node_id"]) ? -1 : 1;
        });
      } else {
        items.sort((a, b) =>
          isDesc ? a[column] - b[column] : b[column] - a[column]
        );
      }
      return items;
    },
    customSortStimulus(items, column, isDesc = false) {
      if (column == "stimulus_id") {
        items.sort((a, b) => {
          return Number(a["stimulus_order"]) < Number(b["stimulus_order"])
            ? -1
            : 1;
        });
      } else {
        items.sort((a, b) =>
          isDesc ? a[column] - b[column] : b[column] - a[column]
        );
      }
      return items;
    },
    customSortHistories(items, column, isDesc = false) {
      if (column == "approach_offset") {
        items.sort((a, b) => {
          let first_date = moment(a["created_at"]).format("YYYY-MM-DD");
          let second_date = moment(b["created_at"]).format("YYYY-MM-DD");
          if (first_date == second_date) {
            if (a["approach_offset"] == b["approach_offset"]) {
              return Number(a["approach_time"].substring(0, 2)) <
                Number(b["approach_time"].substring(0, 2))
                ? -1
                : 1;
            } else {
              return Number(a["approach_offset"]) < Number(b["approach_offset"])
                ? -1
                : 1;
            }
          } else {
            return first_date < second_date ? -1 : 1;
          }
        });
      } else {
        if (isDesc == false || isDesc == true) {
          items.sort((a, b) =>
            isDesc ? a[column] - b[column] : b[column] - a[column]
          );
        }
      }
      return items;
    },
    createHistoryRates(stHis) {
      stHis.taxaInteresse = stHis.accessed / stHis.notified || 0;
      stHis.taxaLogados = stHis.logged_in / stHis.accessed || 0;
      stHis.taxaDealViewed = (stHis.deal_viewed || 0) / stHis.logged_in || 0;
      stHis.taxaConversao = stHis.proposal_confirmed / stHis.logged_in || 0;
      stHis.taxaImplantacao =
        stHis.proposal_agreed / stHis.proposal_confirmed || 0;
      stHis.ppp = stHis.avg_potential / stHis.proposal_agreed || 0;
      stHis.cc =
        stHis.down_payment_potential / (stHis.notified * stHis.approach_cost) ||
        0;

      return stHis;
    },
    createHistoryRatesSms(stHis) {
      stHis.taxaInteresse = stHis.accessed / stHis.notified || 0;
      stHis.taxaLogados = stHis.logged_in / stHis.accessed || 0;
      stHis.taxaDealViewed = (stHis.deal_viewed || 0) / stHis.logged_in || 0;
      stHis.taxaConversao = stHis.proposal_confirmed / stHis.logged_in || 0;
      stHis.taxaImplantacao =
        stHis.proposal_agreed / stHis.proposal_confirmed || 0;
      stHis.ppp = stHis.avg_potential / stHis.proposal_agreed || 0;
      stHis.cc = stHis.down_payment_potential / stHis.notification_cost || 0;

      return stHis;
    },
    setSkipsNodes(node) {
      this.skipObj = node.skipObj;
      this.skipObj.debt_node_id = node.debt_node_id;
      this.skipObj.debt_node_name = node.debt_node_name;

      this.dialog = true;
    },
    setSkipsStimulus(stimulus) {
      this.skipObj = stimulus.skipObj;
      this.skipObj.stimulus_id = stimulus.stimulus_id;
      this.skipObj.stimulus_name = stimulus.stimulus_name.name;
      this.skipObj.stimulus_order = stimulus.stimulus_name.order;

      this.dialog = true;
    },
    setSkipsHistories(history) {
      this.skipObj = history.skipObj || {};
      this.skipObj.approach_offset = history.approach_offset;
      this.skipObj.approach_time = history.approach_time;

      this.dialog = true;
    },
    // Utilizdo no node e stimulus
    setSkipObject(stHis, skipObj = { show: false }) {
      if (stHis.approach_type.includes("SKIP")) {
        if (!skipObj[stHis.approach_type]) {
          skipObj[stHis.approach_type] = 0;
        }
        skipObj[stHis.approach_type] += stHis.contacts;
      } else {
        if (stHis.approach_type.includes("WAIT")) {
          if (!skipObj[stHis.approach_type]) {
            skipObj[stHis.approach_type] = 0;
          }
          skipObj[stHis.approach_type] += stHis.contacts;
        }
      }

      if (skipObj[stHis.approach_type]) {
        skipObj.show = true;
      }

      return skipObj;
    },
    setStimulus(stimulusHistories) {
      let self = this;
      let nodeIdsObj = {};
      this.nodesArray = [];

      stimulusHistories.forEach((stHis) => {
        if (nodeIdsObj[stHis.debt_node_id]) {
          nodeIdsObj[stHis.debt_node_id].sumAmountCost +=
            stHis.notified * stHis.approach_cost;
          nodeIdsObj[stHis.debt_node_id].sumAmountCustomers += stHis.customers;
          nodeIdsObj[stHis.debt_node_id].sumAmountContacts += stHis.contacts;
          nodeIdsObj[stHis.debt_node_id].sumAmountNotified += stHis.notified;
          nodeIdsObj[stHis.debt_node_id].sumAmountDelivered += (stHis.delivered || 0);
          nodeIdsObj[stHis.debt_node_id].sumAmountAccessed += stHis.accessed;
          nodeIdsObj[stHis.debt_node_id].sumAmountLoggedIn += stHis.logged_in;
          nodeIdsObj[stHis.debt_node_id].sumAmountDealViewed += (stHis.deal_viewed || 0);
          nodeIdsObj[stHis.debt_node_id].sumAmountProposalConfirmed +=
            stHis.proposal_confirmed;
          nodeIdsObj[stHis.debt_node_id].sumAmountProposalAgreed +=
            stHis.proposal_agreed;
          nodeIdsObj[stHis.debt_node_id].sumAmountAvgPotential +=
            stHis.avg_potential;
          nodeIdsObj[stHis.debt_node_id].sumAmountDownPaymentPotential +=
            stHis.down_payment_potential;
          nodeIdsObj[stHis.debt_node_id].taxaDelivered = nodeIdsObj[stHis.debt_node_id].sumAmountNotified
              ? nodeIdsObj[stHis.debt_node_id].sumAmountDelivered /
                nodeIdsObj[stHis.debt_node_id].sumAmountNotified : 0,
          nodeIdsObj[stHis.debt_node_id].taxaInteresse =
            nodeIdsObj[stHis.debt_node_id].sumAmountAccessed /
              nodeIdsObj[stHis.debt_node_id].sumAmountNotified || 0;
          nodeIdsObj[stHis.debt_node_id].taxaLogados =
            nodeIdsObj[stHis.debt_node_id].sumAmountLoggedIn /
              nodeIdsObj[stHis.debt_node_id].sumAmountAccessed || 0;
          nodeIdsObj[stHis.debt_node_id].taxaDealViewed =
            nodeIdsObj[stHis.debt_node_id].sumAmountDealViewed /
              nodeIdsObj[stHis.debt_node_id].sumAmountLoggedIn || 0;
          nodeIdsObj[stHis.debt_node_id].taxaConversao =
            nodeIdsObj[stHis.debt_node_id].sumAmountProposalConfirmed /
              nodeIdsObj[stHis.debt_node_id].sumAmountLoggedIn || 0;
          nodeIdsObj[stHis.debt_node_id].taxaImplantacao =
            nodeIdsObj[stHis.debt_node_id].sumAmountProposalAgreed /
              nodeIdsObj[stHis.debt_node_id].sumAmountProposalConfirmed || 0;
          nodeIdsObj[stHis.debt_node_id].ppp =
            nodeIdsObj[stHis.debt_node_id].sumAmountAvgPotential /
              nodeIdsObj[stHis.debt_node_id].sumAmountProposalAgreed || 0;
          nodeIdsObj[stHis.debt_node_id].cc =
            nodeIdsObj[stHis.debt_node_id].sumAmountDownPaymentPotential /
              nodeIdsObj[stHis.debt_node_id].sumAmountCost || 0;
          nodeIdsObj[stHis.debt_node_id].histories.push(
            Object.assign({}, stHis)
          );
          nodeIdsObj[stHis.debt_node_id].skipObj = self.setSkipObject(
            stHis,
            nodeIdsObj[stHis.debt_node_id].skipObj
          );
        } else {
          nodeIdsObj[stHis.debt_node_id] = {
            debt_node_id: stHis.debt_node_id,
            sumAmountCost: stHis.notified * stHis.approach_cost,
            sumAmountCustomers: stHis.customers,
            sumAmountContacts: stHis.contacts,
            sumAmountNotified: stHis.notified,
            sumAmountDelivered: (stHis.delivered || 0),
            sumAmountAccessed: stHis.accessed,
            sumAmountLoggedIn: stHis.logged_in,
            sumAmountDealViewed: (stHis.deal_viewed || 0),
            sumAmountProposalConfirmed: stHis.proposal_confirmed,
            sumAmountProposalAgreed: stHis.proposal_agreed,
            sumAmountAvgPotential: stHis.avg_potential,
            sumAmountDownPaymentPotential: stHis.down_payment_potential,
            taxaDelivered: stHis.notified
              ? (stHis.delivered || 0) / stHis.notified : 0,
            taxaInteresse: stHis.accessed / stHis.notified || 0,
            taxaLogados: stHis.logged_in / stHis.accessed || 0,
            taxaDealViewed: (stHis.deal_viewed || 0) / stHis.logged_in || 0,
            taxaConversao: stHis.proposal_confirmed / stHis.logged_in || 0,
            taxaImplantacao:
              stHis.proposal_agreed / stHis.proposal_confirmed || 0,
            ppp: stHis.avg_potential / stHis.proposal_agreed || 0,
            cc:
              stHis.down_payment_potential /
                (stHis.notified * stHis.approach_cost) || 0,
            skipObj: self.setSkipObject(stHis),
            histories: [Object.assign({}, stHis)],
          };
        }
      });

      Object.keys(nodeIdsObj).forEach((k) => {
        this.nodesArray.push(nodeIdsObj[k]);
      });

      this.nodesArray.forEach((node) => {
        let stimulusObj = {};
        let stimulusArray = [];
        node.histories.forEach((hist) => {
          if (stimulusObj[hist.stimulus_id]) {
            stimulusObj[hist.stimulus_id].sumAmountCost +=
              hist.notified * hist.approach_cost;
            stimulusObj[hist.stimulus_id].sumAmountCustomers += hist.customers;
            stimulusObj[hist.stimulus_id].sumAmountContacts += hist.contacts;
            stimulusObj[hist.stimulus_id].sumAmountNotified += hist.notified;
            stimulusObj[hist.stimulus_id].sumAmountDelivered += (hist.delivered || 0);
            stimulusObj[hist.stimulus_id].sumAmountAccessed += hist.accessed;
            stimulusObj[hist.stimulus_id].sumAmountLoggedIn += hist.logged_in;
            stimulusObj[hist.stimulus_id].sumAmountDealViewed += (hist.deal_viewed || 0);
            stimulusObj[hist.stimulus_id].sumAmountProposalConfirmed +=
              hist.proposal_confirmed;
            stimulusObj[hist.stimulus_id].sumAmountProposalAgreed +=
              hist.proposal_agreed;
            stimulusObj[hist.stimulus_id].sumAmountAvgPotential +=
              hist.avg_potential;
            stimulusObj[hist.stimulus_id].sumAmountDownPaymentPotential +=
              hist.down_payment_potential;
            stimulusObj[hist.stimulus_id].taxaDelivered = stimulusObj[hist.stimulus_id].sumAmountNotified
              ? stimulusObj[hist.stimulus_id].sumAmountDelivered /
                stimulusObj[hist.stimulus_id].sumAmountNotified  : 0,
            stimulusObj[hist.stimulus_id].taxaInteresse =
              stimulusObj[hist.stimulus_id].sumAmountAccessed /
                stimulusObj[hist.stimulus_id].sumAmountNotified || 0;
            stimulusObj[hist.stimulus_id].taxaLogados =
              stimulusObj[hist.stimulus_id].sumAmountLoggedIn /
                stimulusObj[hist.stimulus_id].sumAmountAccessed || 0;
            stimulusObj[hist.stimulus_id].taxaDealViewed =
              stimulusObj[hist.stimulus_id].sumAmountDealViewed /
                stimulusObj[hist.stimulus_id].sumAmountLoggedIn || 0;
            stimulusObj[hist.stimulus_id].taxaConversao =
              stimulusObj[hist.stimulus_id].sumAmountProposalConfirmed /
                stimulusObj[hist.stimulus_id].sumAmountLoggedIn || 0;
            stimulusObj[hist.stimulus_id].taxaImplantacao =
              stimulusObj[hist.stimulus_id].sumAmountProposalAgreed /
                stimulusObj[hist.stimulus_id].sumAmountProposalConfirmed || 0;
            stimulusObj[hist.stimulus_id].ppp =
              stimulusObj[hist.stimulus_id].sumAmountAvgPotential /
                stimulusObj[hist.stimulus_id].sumAmountProposalAgreed || 0;
            stimulusObj[hist.stimulus_id].cc =
              stimulusObj[hist.stimulus_id].sumAmountDownPaymentPotential /
                stimulusObj[hist.stimulus_id].sumAmountCost || 0;
            stimulusObj[hist.stimulus_id].skipObj = self.setSkipObject(
              hist,
              stimulusObj[hist.stimulus_id].skipObj
            );
            stimulusObj[hist.stimulus_id].histories.push(
              Object.assign({}, this.createHistoryRates(hist))
            );
            stimulusObj[hist.stimulus_id].firing_id.push(hist.firing_id);
          } else {
            stimulusObj[hist.stimulus_id] = {
              stimulus_id: hist.stimulus_id,
              firing_id: Object.assign([hist.firing_id]),
              stimulus_name: hist.stimulus_name.name,
              stimulus_order: hist.stimulus_name.order,
              sumAmountCost: hist.notified * hist.approach_cost,
              sumAmountCustomers: hist.customers,
              sumAmountContacts: hist.contacts,
              sumAmountAccessed: hist.accessed,
              sumAmountNotified: hist.notified,
              sumAmountDelivered: (hist.delivered || 0),
              sumAmountLoggedIn: hist.logged_in,
              sumAmountDealViewed: (hist.deal_viewed || 0),
              sumAmountProposalConfirmed: hist.proposal_confirmed,
              sumAmountProposalAgreed: hist.proposal_agreed,
              sumAmountAvgPotential: hist.avg_potential,
              sumAmountDownPaymentPotential: hist.down_payment_potential,
              taxaDelivered: hist.notified
                ? (hist.delivered || 0) / hist.notified : 0,
              taxaInteresse: hist.accessed / hist.notified || 0,
              taxaLogados: hist.logged_in / hist.accessed || 0,
              taxaDealViewed: (hist.deal_viewed || 0) / hist.logged_in || 0,
              taxaConversao: hist.proposal_confirmed / hist.logged_in || 0,
              taxaImplantacao:
                hist.proposal_agreed / hist.proposal_confirmed || 0,
              ppp: hist.avg_potential / hist.proposal_agreed || 0,
              cc:
                hist.down_payment_potential /
                  (hist.notified * hist.approach_cost) || 0,
              creditor_id: hist.creditor_id,
              customers: hist.customers,
              debt_node_id: hist.debt_node_id,
              hot: hist.hot,
              id: hist.id,
              stimulus_content: hist.stimulus_content,
              gateway_id: hist.gateway_id,
              skipObj: self.setSkipObject(hist),
              histories: [Object.assign({}, this.createHistoryRates(hist))],
            };
          }
        });
        delete node.histories;

        let totalSkips = 0;
        Object.keys(node.skipObj).forEach((skipkey) => {
          if (typeof node.skipObj[skipkey] == "number") {
            totalSkips += node.skipObj[skipkey];
          }
        });

        node.skipObj.totalSkips = totalSkips;
        node.skipObj.sumAmountContacts = node.sumAmountContacts;
        node.skipObj.sumAmountNotified = node.sumAmountNotified;
        node.skipObj.not_notified =
          node.sumAmountContacts - node.sumAmountNotified;
        node.skipObj.missing =
          node.skipObj.not_notified - node.skipObj.totalSkips;
        node.skipObj.total = node.skipObj.totalSkips + node.skipObj.missing;
        node.skipObj.color = "purple";

        if (node.skipObj["SKIP_INCONSISTENT_VAR"])
          node.skipObj.color = "orange";
        if (node.skipObj.missing) node.skipObj.color = "red";

        Object.keys(stimulusObj).forEach((k) => {
          stimulusObj[k].historySkipsArray = stimulusObj[k].histories.filter(
            (h) => h.approach_type.includes("SKIP")
          );
          stimulusObj[k].histories = stimulusObj[k].histories.filter(
            (h) => !h.approach_type.includes("SKIP")
          );
          stimulusObj[k].histories = stimulusObj[k].histories.filter(
            (h) => !h.approach_type.includes("WAIT")
          ); // filtra para que WAIT nao apareça no histories
          let historySkipsObj = {};

          stimulusObj[k].historySkipsArray.forEach((hSkip) => {
            if (
              !historySkipsObj[
                `${hSkip.approach_offset}-${hSkip.approach_time}`
              ]
            ) {
              historySkipsObj[
                `${hSkip.approach_offset}-${hSkip.approach_time}`
              ] = { show: false };
            }
            if (
              !historySkipsObj[
                `${hSkip.approach_offset}-${hSkip.approach_time}`
              ][hSkip.approach_type]
            ) {
              historySkipsObj[
                `${hSkip.approach_offset}-${hSkip.approach_time}`
              ][hSkip.approach_type] = 0;
            }
            historySkipsObj[`${hSkip.approach_offset}-${hSkip.approach_time}`][
              hSkip.approach_type
            ] += hSkip.contacts;
            if (
              historySkipsObj[
                `${hSkip.approach_offset}-${hSkip.approach_time}`
              ][hSkip.approach_type] > 0
            ) {
              historySkipsObj[
                `${hSkip.approach_offset}-${hSkip.approach_time}`
              ].show = true;
            }
          });

          let historiesAggregateObj = {};
          stimulusObj[k].histories.forEach((history) => {
            if (
              !historiesAggregateObj[
                `${history.approach_offset}-${history.approach_time}-${moment(
                  history.created_at
                ).format("DD-MM-YYYY")}`
              ]
            ) {
              historiesAggregateObj[
                `${history.approach_offset}-${history.approach_time}-${moment(
                  history.created_at
                ).format("DD-MM-YYYY")}`
              ] = Object.assign({}, history);
              historiesAggregateObj[
                `${history.approach_offset}-${history.approach_time}-${moment(
                  history.created_at
                ).format("DD-MM-YYYY")}`
              ].notification_cost = history.notified * history.approach_cost;
            } else {
              historiesAggregateObj[
                `${history.approach_offset}-${history.approach_time}-${moment(
                  history.created_at
                ).format("DD-MM-YYYY")}`
              ].contacts += history.contacts;
              historiesAggregateObj[
                `${history.approach_offset}-${history.approach_time}-${moment(
                  history.created_at
                ).format("DD-MM-YYYY")}`
              ].customers += history.customers;
              historiesAggregateObj[
                `${history.approach_offset}-${history.approach_time}-${moment(
                  history.created_at
                ).format("DD-MM-YYYY")}`
              ].notified += history.notified;
              historiesAggregateObj[
                `${history.approach_offset}-${history.approach_time}-${moment(
                  history.created_at
                ).format("DD-MM-YYYY")}`
              ].delivered += history.delivered;
              historiesAggregateObj[
                `${history.approach_offset}-${history.approach_time}-${moment(
                  history.created_at
                ).format("DD-MM-YYYY")}`
              ].accessed += history.accessed;
              historiesAggregateObj[
                `${history.approach_offset}-${history.approach_time}-${moment(
                  history.created_at
                ).format("DD-MM-YYYY")}`
              ].logged_in += history.logged_in;
              historiesAggregateObj[
                `${history.approach_offset}-${history.approach_time}-${moment(
                  history.created_at
                ).format("DD-MM-YYYY")}`
              ].deal_viewed = (historiesAggregateObj[
                `${history.approach_offset}-${history.approach_time}-${moment(
                  history.created_at
                ).format("DD-MM-YYYY")}`
              ].deal_viewed || 0) + (history.deal_viewed || 0);
              historiesAggregateObj[
                `${history.approach_offset}-${history.approach_time}-${moment(
                  history.created_at
                ).format("DD-MM-YYYY")}`
              ].proposal_confirmed += history.proposal_confirmed;
              historiesAggregateObj[
                `${history.approach_offset}-${history.approach_time}-${moment(
                  history.created_at
                ).format("DD-MM-YYYY")}`
              ].proposal_agreed += history.proposal_agreed;
              historiesAggregateObj[
                `${history.approach_offset}-${history.approach_time}-${moment(
                  history.created_at
                ).format("DD-MM-YYYY")}`
              ].avg_potential += history.avg_potential;
              historiesAggregateObj[
                `${history.approach_offset}-${history.approach_time}-${moment(
                  history.created_at
                ).format("DD-MM-YYYY")}`
              ].down_payment_potential += history.down_payment_potential;
              historiesAggregateObj[
                `${history.approach_offset}-${history.approach_time}-${moment(
                  history.created_at
                ).format("DD-MM-YYYY")}`
              ].notification_cost += history.notified * history.approach_cost;
            }
          });
          let historiesAggregateArray = [];
          Object.keys(historiesAggregateObj).forEach((hist) => {
            historiesAggregateArray.push(
              this.createHistoryRatesSms(historiesAggregateObj[hist])
            );
          });

          stimulusObj[k].histories = historiesAggregateArray;
          let totalSkips = 0;
          Object.keys(stimulusObj[k].skipObj).forEach((skipkey) => {
            if (typeof stimulusObj[k].skipObj[skipkey] == "number") {
              totalSkips += stimulusObj[k].skipObj[skipkey];
            }
          });
          stimulusObj[k].skipObj.totalSkips = totalSkips;
          stimulusObj[k].skipObj.sumAmountContacts =
            stimulusObj[k].sumAmountContacts;
          stimulusObj[k].skipObj.sumAmountNotified =
            stimulusObj[k].sumAmountNotified;
          stimulusObj[k].skipObj.not_notified =
            stimulusObj[k].sumAmountContacts - stimulusObj[k].sumAmountNotified;
          stimulusObj[k].skipObj.missing =
            stimulusObj[k].skipObj.not_notified -
            stimulusObj[k].skipObj.totalSkips;
          stimulusObj[k].skipObj.total =
            stimulusObj[k].skipObj.totalSkips + stimulusObj[k].skipObj.missing;
          stimulusObj[k].skipObj.color = "purple";

          if (stimulusObj[k].skipObj["SKIP_INCONSISTENT_VAR"])
            stimulusObj[k].skipObj.color = "orange";
          if (stimulusObj[k].skipObj.missing)
            stimulusObj[k].skipObj.color = "red";

          stimulusArray.push(stimulusObj[k]);
          node.stimulus = [...stimulusArray];
        });
      });
    },
    sumAmount(arrayToSum, field) {
      let totalValue = 0;

      arrayToSum.filter((item) => {
        if (item[field] >= 0) {
          totalValue += parseInt(item[field]);
        }
      });

      return totalValue;
    },

    selectContent(props) {
      if (props.item.approach_type == "EMAIL") {
        return props.item.stimulus_content.subject;
      } else if (props.item.approach_type == "PUSH") {
        return props.item.stimulus_content.body;
      } else if (props.item.approach_type == "SMS") {
        return props.item.stimulus_content.text;
      } else if (props.item.approach_type == "WHATSAPP") {
        return props.item.stimulus_content.message;
      }
    },
    isRetroactive(value = "") {
      if (value.toLowerCase().includes("retroactive")) {
        let values = [];
        values = value.split(" ");
        let first_time = values[0].substring(0, 2);
        let second_time = values[2].substring(0, 2);
        return `<span><span style="color: orange; font-weight: bold">${first_time}h</span> <br> atrasado das ${second_time}</span>`;
      } else {
        return `<span>${value.substring(0, 2)}</span>`;
      }
    },
    getRange(startOffset = 0, endOffset = 0, period = "day") {
      return [
        moment().subtract(startOffset, period).startOf(period),
        moment().subtract(endOffset, period).endOf(period),
      ];
    },
    handleChange(values) {
      this.setStartDate(moment(values[0]._d).format("YYYY-MM-DD"));
      this.setEndDate(moment(values[1]._d).format("YYYY-MM-DD"));
    },
    async expansorNode(props) {
      props.expanded = !props.expanded;
      this.stimulus = props.item.stimulus;
    },
    async expansorStimulus(props) {
      props.expanded = !props.expanded;
      this.histories = props.item.histories;
    },
    setSelectTree(type, prop) {
      switch (type) {
        case "ANALYZABLE":
          switch (prop) {
            case "icom":
              return "mdi-pause-circle-outline";
            case "color":
              return "grey darken-2";
            case "background":
              return "grey lighten-2";
          }
          break;
        case "STIMULATE":
          switch (prop) {
            case "icom":
              return "mdi-play-circle-outline";
            case "color":
              return "grey darken-2";
            case "background":
              return "grey lighten-2";
          }
          break;
        case "ARCHIVED":
          switch (prop) {
            case "icom":
              return "mdi-archive-outline";
            case "color":
              return "grey";
            case "background":
              return "grey lighten-3";
          }
          break;
      }
    },
  },
};
</script>
<style lang="scss">
.stimulus-history {
  .v-table tbody td,
  table.v-table tbody tr:nth-of-type(1) th {
    height: 30px !important;
  }
}
</style>

<style scoped>
tr {
  cursor: default;
}
.text-orange {
  color: orange;
  font-weight: bold;
}
.text-red {
  color: red;
  font-weight: bold;
}

.tr-shadow {
  background-color: rgba(0, 0, 0, 0.06);
}

.hot {
  background-color: #f47d76 !important;
  border-color: #f47d76 !important;
}

.checkbox {
  background-color: #e0f2f1;
  padding: 25px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
}

.received {
  background-color: #d3ffce !important;
  border-color: #d3ffce !important;
}

.span-range {
  display: inline-block;
  width: 45%;
  font-size: small;
}

.good-accurancy {
  font-size: 12px;
  color: #049804;
  font-weight: 400;
}

.v-date-picker-table {
  height: auto !important;
}

.v-date-range .v-menu--inline {
  display: inline;
}

.hot .v-chip__content {
  padding: 4px 5px !important;
  background-color: #f47d76 !important;
  border-color: #f47d76 !important;
}

.received .v-chip__content {
  background-color: #d3ffce !important;
  border-color: #d3ffce !important;
  padding: 0px 9px !important;
}
::v-deep table.v-table tbody td:first-child,
table.v-table tbody td:not(:first-child),
table.v-table tbody th:first-child,
table.v-table tbody th:not(:first-child),
table.v-table thead td:first-child,
table.v-table thead td:not(:first-child),
table.v-table thead th:first-child,
table.v-table thead th:not(:first-child) {
  padding-right: 0px !important;
  padding-left: 0px !important;
}
</style>
